import { required } from '@vuelidate/validators'

export const OneCValidation = {
    from_date: { required },
    to_date: { required },
}
